// src/pages/Forgot.js
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/forgot.css";
import { Link } from "react-router-dom";
import leftImage from "../assets/landing1.png";
import { postJson } from "../network/api";
import { ApiEndpoints } from "../network/config";

const Forgot = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success"); // success | error
  const [popupTitle, setPopupTitle] = useState("");
  const [popupSubtitle, setPopupSubtitle] = useState("");

  const navigate = useNavigate();
  const closeTimerRef = useRef(null);
  const redirectTimerRef = useRef(null);

  // Auto-close popup after 2 sec + redirect after success (handled separately)
  useEffect(() => {
    if (showPopup) {
      closeTimerRef.current = setTimeout(() => {
        setShowPopup(false);
        // note: redirect handled where needed (we also keep redirectTimerRef for explicit navigation)
      }, 2000);
    }
    return () => {
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
    };
  }, [showPopup]);

  // Popup helper
  const show = (type, title, subtitle) => {
    setPopupType(type);
    setPopupTitle(title);
    setPopupSubtitle(subtitle);
    setShowPopup(true);
  };

  // Submit handler
  const handleGetOTP = async (e) => {
    e.preventDefault();

    if (!mobileNumber.trim() || !/^\d{10}$/.test(mobileNumber)) {
      return show("error", "Invalid Mobile Number", "Please enter a valid 10-digit mobile number.");
    }

    try {
      const res = await postJson(ApiEndpoints.verifyMobileNumber, {
        mobileNumber: mobileNumber,
      });

      // If API returned an explicit failure structure even with 200, show that message only
      if (res && (res.success === false || res?.error)) {
        const apiMessage =
          res?.error?.message ||
          res?.message ||
          (typeof res === "string" ? res : "Mobile verification failed.");
        return show("error", "Verification Failed", apiMessage);
      }

      // Treat as success
      // Use API message if available, else default
      const successMsg = (res && (res.message || (res.data && res.data.message))) || `OTP sent to ${mobileNumber}`;

      show("success", "Verified", successMsg);

      // ensure any previous redirect timer is cleared
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current);
        redirectTimerRef.current = null;
      }

      // Redirect after 1.5s (to allow popup to show)
      redirectTimerRef.current = setTimeout(() => {
        redirectTimerRef.current = null;
        navigate("/passwordreset", {
          state: {
            mobileNumber: mobileNumber,
            purpose: "password-reset",
          },
        });
      }, 1500);

      return;
    } catch (err) {
      // Try to extract useful message from thrown error
      let message = "Something went wrong. Please try again.";

      try {
        if (err?.body) {
          const parsed = JSON.parse(err.body);
          message = parsed?.error?.message || parsed?.message || message;
        } else if (err?.message) {
          message = err.message;
        }
      } catch (parseErr) {
        // ignore parse error and keep generic message
      }

      show("error", "Verification Error", message);
    }
  };

  // cleanup timers on unmount
  useEffect(() => {
    return () => {
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current);
        redirectTimerRef.current = null;
      }
    };
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleGetOTP(e);
  };

  return (
    <div className="forgot-page">
      {/* Popup */}
      {showPopup && (
        <div className={`popup-message`} role="alert">
          <div className="popup-card-content">
            <div className={`popup-icon ${popupType === "success" ? "success-icon" : "error-icon"}`}>
              {popupType === "success" ? "✓" : "⚠"}
            </div>
            <div className="popup-text">
              <p className="popup-title">{popupTitle}</p>
              <p className="popup-subtitle">{popupSubtitle}</p>
            </div>
          </div>
        </div>
      )}

      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Section */}
      <div className="right-side">
        <div className="forgot-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          {/*<p className="note">
            <b>Note:</b> If you already have an account, please log in. <br />
            New users can click on Register to create a new account.
          </p>*/}

          {/*<hr className="divider" />*/}

          <h2 className="forgot-title">Forgot Password</h2>

          <form onSubmit={handleGetOTP}>
            <div className="form-group">
              <label className="input-label">Mobile Number*</label>
              <input
                type="text"
                placeholder="Enter Mobile Number"
                className="form-input"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ""))}
                onKeyPress={handleKeyPress}
                maxLength="10"
              />
            </div>

            <button type="submit" className="otp-btn">
              Verify
            </button>
          </form>

          {/*
          <hr className="divider" />
          <p className="register">
            Don't have an account?{" "}
            <Link to="/registerphone" className="register-link">
              Register
            </Link>
          </p>
          */}
        </div>
      </div>
    </div>
  );
};

export default Forgot;
